var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2364_9950)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0.5 0.5)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2364_9950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4998 8.49915C16.4998 10.6209 15.6569 12.6557 14.1566 14.156C12.6563 15.6563 10.6215 16.4991 8.49976 16.4991C6.37802 16.4991 4.34319 15.6563 2.8429 14.156C1.34261 12.6557 0.499756 10.6209 0.499756 8.49915C0.499756 6.37741 1.34261 4.34258 2.8429 2.84229C4.34319 1.342 6.37802 0.499146 8.49976 0.499146C10.6215 0.499146 12.6563 1.342 14.1566 2.84229C15.6569 4.34258 16.4998 6.37741 16.4998 8.49915ZM8.99976 4.99915C8.99976 4.86654 8.94708 4.73936 8.85331 4.64559C8.75954 4.55182 8.63236 4.49915 8.49976 4.49915C8.36715 4.49915 8.23997 4.55182 8.1462 4.64559C8.05243 4.73936 7.99976 4.86654 7.99976 4.99915V7.99915H4.99976C4.86715 7.99915 4.73997 8.05182 4.6462 8.14559C4.55243 8.23936 4.49976 8.36654 4.49976 8.49915C4.49976 8.63175 4.55243 8.75893 4.6462 8.8527C4.73997 8.94647 4.86715 8.99915 4.99976 8.99915H7.99976V11.9991C7.99976 12.1318 8.05243 12.2589 8.1462 12.3527C8.23997 12.4465 8.36715 12.4991 8.49976 12.4991C8.63236 12.4991 8.75954 12.4465 8.85331 12.3527C8.94708 12.2589 8.99976 12.1318 8.99976 11.9991V8.99915H11.9998C12.1324 8.99915 12.2595 8.94647 12.3533 8.8527C12.4471 8.75893 12.4998 8.63175 12.4998 8.49915C12.4998 8.36654 12.4471 8.23936 12.3533 8.14559C12.2595 8.05182 12.1324 7.99915 11.9998 7.99915H8.99976V4.99915Z",
    fill: "#0D6EFD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2364_9950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2364_9950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconBlue);
export default __webpack_public_path__ + "static/media/add_icon_blue.aa243422fa05a48e15941e62d8c13e21.svg";
export { ForwardRef as ReactComponent };